import { useEffect, useRef, useState } from "react";
import Button from "../components/Buttons/button";
import { MapImage, WorksIcon1, WorksIcon2, WorksIcon3 } from "../assets/imageAssets";
import HowItWorksCard from "../components/HowItWorksCard";

import ProductCard from "../components/ProductCard";
import { profiles_req } from "../api/profiles.api";

const Main = () => {
  const ref = useRef(null);
  const howItWorksRef = useRef(null);
  const [data, setData] = useState([]);
  const scrollDown = () => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };
  const getProfiles = async () => {
    const response = await profiles_req();

    setData(response);
  };
  // useEffect(() => {
  //   howItWorksRef.current?.scrollIntoView({ behavior: "smooth" });
  // }, []);
  useEffect(() => {
    getProfiles();
  }, []);
  return (
    <div className="main-page">
      <div className="profiles-section text-center" ref={ref}>
        <div className="container">
          <div className="profiles-section__top">
            <h1 className="mb-24">Know Where You Stand. Grow From Who You Are.</h1>
            <h6>We use trusted data to help you understand your current reality — not to label you, but to empower you. Growth begins with clarity, and clarity begins with seeing yourself fully.</h6>
          </div>
          <div className="profiles-section__content flex flex-wrap flex-align-start flex-justify-start">
            {data?.result?.map(item => (
              <ProductCard
                key={item.id}
                icon={item.card_image}
                label={item.name}
                // title={item.name}
                description={item.description}
                href={`/profiles/${item.id}/topics`}
                cardColor={item.background_color}
                item={item}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="clarity-starts-here">
        <div className="container">
          <div className="clarity-starts-here__content flex flex-align-center">
            <div className="clarity-starts-here__left">
              <h2 className="mb-24">Clarity Starts Here</h2>
              <p className="mb-40">Gain a clear, data-driven perspective on your position across all parts of life. We use verified data to help you understand your unique place in the world – not for judgment, but for insight.Understanding your current reality is the key to unlocking meaningful growth. Change starts with self-awareness and acceptance. Embrace where you are now, and build authentically towards where you want to be.</p>
              <Button text={"Get Started"} onClick={scrollDown} />
            </div>
            <div className="clarity-starts-here__right">
              <img src={MapImage} alt="Clarity Starts Here" />
            </div>
          </div>
        </div>
      </div>
      <div className="how-it-works text-center">
        <div className="container">
          <div className="how-it-works__head">
            <h3 className="mb-24">How It Works</h3>
            <p className="mb-48">BackToReality makes discovery easy. Pick a topic, answer a few guided questions, and instantly receive a tailored report — complete with charts and takeaways you can trust.</p>
          </div>
          <div className="how-it-works__content flex" ref={howItWorksRef}>
            <HowItWorksCard image={WorksIcon1} title={"Choose a profile and topic"} point={"1"} text={"Start by picking a theme that interests you — then choose the topic you relate to."} />
            <HowItWorksCard image={WorksIcon2} title={"Answer a few quick questions"} point={"2"} text={"Your answers help us tailor a personalized report that reflects your real-life patterns."} />
            <HowItWorksCard image={WorksIcon3} title={"View your data-driven report"} point={"3"} text={"See how you compare to others and explore insights from your answers — instantly."} />
          </div>
        </div>
      </div>
      {/* <div className="pricing-screen">
        <div className="container">
          <div className="pricing-screen__content flex flex-align-center flex-between">
            <div className="pricing-screen__left">
              <p className="medium-text text-color-grey mb-12">
                <strong>Pricing</strong>
              </p>
              <h2 className="mb-24">
                Simple, One-Time <br /> Pricing
              </h2>
              <p>
                Pay once and get lifetime access to your selected report
                experience. No subscriptions. No hidden fees. Just clarity —
                when you want it.
              </p>
            </div>
            <div className="pricing-screen__right">
              <PricingCard
                price={"10"}
                text={"No subscriptions. Just insights."}
                buttonText={"Get started"}
                benefitsList={ONETIME_PRICING_BENEFITS}
                onClick={scrollDown}
              />
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Main;
